<!-- {{activeSlideIndex|json}} ====== {{myInterval|json}} -->
@if (activeSlideIndex != undefined) {
  <carousel [interval]="myInterval" [(activeSlide)]="activeSlideIndex"
    [showIndicators]="showIndicator" [isAnimated]="false" (activeSlideChange)="onSlideChange($event)" [noPause]="true">
    @for (d of doctorPerScreen; track d; let i = $index) {
      <slide>
        @for (doctorDetails of d; track doctorDetails; let s = $index) {
          <div class="float-left desktop" [ngStyle]="calculateStyles(d.length)"
            [ngClass]="s%2==0?'background-black':'background-remove'">
            <div class="_wf-qm-colmain" id="doctorCard">
              <div class="_wf-qm-col1">
                <div class="_wf-qm-cardmain">
                  <div class="_wf-qm-topcard">
                    @if (!doctorDetails.profile_id) {
                      <div class="_wf-qm-profileimage"><img class="imgsize"
                      src="./assets/images/user-profile-image.png"></div>
                    }
                    @if (doctorDetails.profile_id) {
                      <div class="_wf-qm-profileimage"> <img class="imgsize"
                      [src]="doctorDetails.profile_id | secure  | async"></div>
                    }
                    <div class="_wf-qm-profiledetail">
                      <div class="text-block-284">{{doctorDetails.display_name}}</div>
                      <div class="_wf-qm-dentistxt">
                        <div class="text-block-285"><img class="speciality-icon"
                        src="assets/images/icon-qualification-placeholder.png"></div>
                        <div class="text-block-286">{{doctorDetails.speciality}}</div>
                      </div>
                      <div class="text-block-287">
                        {{'field.label.room_number' | translate | async }} :- {{doctorDetails.roomName}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            @if (doctorDetails &&doctorDetails.doctorList && doctorDetails.doctorList[0]) {
              @for (t of doctorDetails.doctorList[0]; track t; let p = $index) {
                <div class="_wf-qm-smallcard" id="patientCard"
                  >
                  <div class="_wf-qm-blueline">
                    <div class="_wf-qm-sidescroll"
                      [ngStyle]="checkStage(t.stage)==true?{'background-color':'#5cbaf1'}:{'background-color':'#7a7a7d'}">
                    </div>
                  </div>
                  @if (t.token_number) {
                    <div id="leftbox">
                      <p>{{'field.label.token_number' | translate | async }}</p>
                      {{t.token_number}}
                    </div>
                  }
                  <div id="middlebox">
                    <p>{{'field.label.uhId' | translate | async }}</p>
                    {{t.uhId}}
                  </div>
                  <div id="rightbox">
                    <p>{{'field.label.time' | translate | async }}</p>
                    {{t.slotStartTime | timeFormat}}
                  </div>
                  <div id="rightbox">
                    <p>{{'field.label.room_number' | translate | async }}</p>
                    {{t.room_name}}
                  </div>
                </div>
              }
            }
          </div>
        }
        <div class="_wf-qm-mainbg">
          @for (doctorDetails of d; track doctorDetails; let s = $index) {
            <div>
              <div class="_wf-qm-maintableheadingdiv" id="doctorCard" (click)="getPatient(doctorDetails)">
                @if (!doctorDetails.profile_id) {
                  <div class="_wf-qm-profilemain">
                    <img class="imgsize" src="./assets/images/user-profile-image.png">
                  </div>
                }
                @if (doctorDetails.profile_id) {
                  <div class="_wf-qm-profilemain">
                    <img class="imgsize" [src]="doctorDetails.profile_id | secure  | async">
                  </div>
                }
                <div class="_wf-qm-profiletxt">
                  <div class="text-block-291 text-capitaliz">{{doctorDetails.display_name}}</div>
                  <div class="_wf-qm-dentistsamltxt">
                    <div class="text-block-292"> <img src="assets/images/icon-qualification-placeholder.png">
                    </div>
                    <div class="text-block-293 text-capitaliz">{{doctorDetails.speciality}}</div>
                  </div>
                  jdhhhdgd
                  <div class="text-block-294 text-capitaliz">{{doctorDetails.roomName}}</div>
                </div>
                @if (!patientList) {
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                }
                @if (patientList && doctorDetails.doctor_id == doctorId) {
                  <i class="fa fa-angle-down"
                  aria-hidden="true"></i>
                }
                @if (patientList && doctorDetails.doctor_id != doctorId) {
                  <i class="fa fa-angle-right"
                  aria-hidden="true"></i>
                }
              </div>
              @if (patientList && doctorDetails.doctor_id == doctorId) {
                <div>
                  @for (t of doctorDetails.doctorList[0]; track t; let p = $index) {
                    <div id="patientCard">
                      <div class="_wf-qm-smallcard _wf-qm-mobilecard">
                        <div class="_wf-qm-blueline">
                          <div class="_wf-qm-sidescroll"
                            [ngStyle]="checkStage(t.stage)==true?{'background-color':'#5cbaf1'}:{'background-color':'#7a7a7d'}">
                          </div>
                        </div>
                        <div class="_wf-qm-shortform">
                          <div class="_wf-qm-namesf">
                            <div class="text-block-288">{{t.patient_name[0]}}</div>
                          </div>
                        </div>
                        <div class="d-flex align-items-center">
                          <div class="_wf-qm-uhidnumber">
                            <div class="text-block-289">UHID - {{t.uhId}}</div>
                          </div>
                          <div class="_wf-qm-tck pr-1">
                            <div class="_wf-qm-circle">
                              <div class="_wf-qm-ticnumber">
                                <div class="text-block-290">{{t.appointmentId}}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      </slide>
    }
  </carousel>
}